import React, {useState} from 'react';
import axios from 'axios';
import {Button, Grid, Input, Message, Modal} from 'semantic-ui-react';
import {PaymentDetailsContext} from "./PaymentDetailsContainer";
import {CustomModalHeader} from '../custom-common';

const toCents = (dollarString) => {
    const normalized = (dollarString || '').replace(/[^0-9.]/g, '');
    const asFloat = parseFloat(normalized);
    if (isNaN(asFloat)) return null;
    return Math.round(asFloat * 100);
};

const PciVerifyAccount = ({setupIntentId}) => {
    const {
        bankAccountVerificationStatus,
        setBankAccountVerificationStatus,
        setBankAccountPm,
    } = PaymentDetailsContext.useContainer();
    const [open, setOpen] = useState(false);
    const [amount1, setAmount1] = useState('');
    const [amount2, setAmount2] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);

    const close = () => {
        if (submitting) return;
        setOpen(false);
        setError(null);
    };

    const onSubmit = async () => {
        setError(null);
        const cents1 = toCents(amount1);
        const cents2 = toCents(amount2);
        if (cents1 === null || cents2 === null || cents1 <= 0 || cents2 <= 0) {
            setError('Please enter both amounts in dollars (e.g. 0.32).');
            return;
        }
        setSubmitting(true);
        try {
            const response = await axios.post(
                '/api/member/v2/verifyPciBank',
                {setupIntentId, amount1: cents1, amount2: cents2},
                {headers: {'Content-Type': 'application/json'}},
            );
            if (response.data && response.data.verified) {
                setOpen(false);
                setBankAccountVerificationStatus("Verified");
                setBankAccountPm(response.data.paymentMethod);
            } else {
                setError(response.data?.error || 'Verification failed. Check the amounts and try again.');
            }
        } catch (e) {
            setError(e?.response?.data?.errorMessage || e?.message || 'Verification failed. Check the amounts and try again.');
        } finally {
            setSubmitting(false);
        }
    };

    if (bankAccountVerificationStatus !== 'Pending verification') {
        return null;
    }

    return (
        <>
            <a onClick={() => setOpen(true)}
               style={{lineHeight: '21px', float: 'right', color: '#43806C'}}
               className={"small bold"}
               href>Verify account</a>
            <Modal onClose={close} open={open} size="small">
                <CustomModalHeader title="Verify your bank account" onClose={close} className="customModalHeader"/>
                <Modal.Content>
                    <p>Two small deposits have been sent to your bank account. Enter both amounts below to verify.</p>
                    <Grid columns={2} stackable>
                        <Grid.Row>
                            <Grid.Column>
                                <label className="requiredField" htmlFor="pci-amount-1">Amount 1</label>
                                <Input id="pci-amount-1" placeholder="0.32" value={amount1}
                                       onChange={(_, {value}) => setAmount1(value)}
                                       disabled={submitting} fluid/>
                            </Grid.Column>
                            <Grid.Column>
                                <label className="requiredField" htmlFor="pci-amount-2">Amount 2</label>
                                <Input id="pci-amount-2" placeholder="0.45" value={amount2}
                                       onChange={(_, {value}) => setAmount2(value)}
                                       disabled={submitting} fluid/>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    {error && <Message negative content={error}/>}
                </Modal.Content>
                <Modal.Actions>
                    <Button color="grey" basic onClick={close} disabled={submitting}>Cancel</Button>
                    <Button primary onClick={onSubmit} loading={submitting} disabled={submitting}>Verify account</Button>
                </Modal.Actions>
            </Modal>
        </>
    );
};

export default PciVerifyAccount;
